import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, ax, card, btn, inp, ImageUploadZone } from './adminHelpers';

export default function BackdropsTab() {
  const [backdrops, setBackdrops] = useState([]);
  const [form, setForm] = useState({ name: '', price_addon: '' });
  const [file, setFile] = useState(null);
  const [editing, setEditing] = useState(null);

  const load = () => ax().get(`${API}/api/admin/backdrops`).then(r => setBackdrops(r.data.backdrops)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    const fd = new FormData();
    fd.append('name', form.name);
    fd.append('price_addon', form.price_addon || 0);
    if (file) fd.append('image', file);

    if (editing) {
      await axios.patch(`${API}/api/admin/backdrops/${editing}`, fd, { withCredentials: true });
    } else {
      await axios.post(`${API}/api/admin/backdrops`, fd, { withCredentials: true });
    }
    setEditing(null);
    setForm({ name: '', price_addon: '' });
    setFile(null);
    load();
  };

  const del = async (id) => { if (window.confirm('Delete backdrop?')) { await ax().delete(`${API}/api/admin/backdrops/${id}`); load(); } };
  const edit = (b) => { setEditing(b.id); setForm({ name: b.name, price_addon: b.price_addon }); setFile(null); };

  return (
    <div>
      <div style={card}>
        <h3 style={{ margin: '0 0 16px', color: '#9F5CFF', fontSize: 15 }}>{editing ? 'Edit Backdrop' : 'Add Backdrop'}</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
          <input placeholder="Backdrop name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inp(false)} />
          <input placeholder="Price add-on ($)" type="number" value={form.price_addon} onChange={e => setForm({ ...form, price_addon: e.target.value })} style={inp(false)} />
        </div>

        <ImageUploadZone label="Upload Backdrop Image" file={file} onChange={e => setFile(e.target.files[0])} />

        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={save} style={btn('#9F5CFF')}>💾 Save Backdrop</button>
          {editing && (
            <button onClick={() => { setEditing(null); setForm({ name: '', price_addon: '' }); setFile(null); }} style={btn('#555', true)}>
              Cancel
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))', gap: 14 }}>
        {backdrops.map(b => (
          <div key={b.id} style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.07)' }}>
            {b.image_url
              ? <img src={b.image_url} alt={b.name} style={{ width: '100%', height: 120, objectFit: 'cover' }} />
              : <div style={{ width: '100%', height: 120, background: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 30 }}>🚫</span>
                </div>
            }
            <div style={{ padding: '10px 12px' }}>
              <p style={{ margin: '0 0 2px', fontSize: 13, color: '#fff', fontWeight: 600 }}>{b.name}</p>
              <p style={{ margin: '0 0 10px', fontSize: 12, color: '#27C85A' }}>+${parseFloat(b.price_addon || 0).toFixed(2)}</p>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => edit(b)} style={{ ...btn('#9F5CFF', true), fontSize: 11 }}>Edit</button>
                <button onClick={() => del(b.id)} style={{ ...btn('#E34364', true), fontSize: 11 }}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
